<template>
	<div class="template location">
		<div class="panel_wrap">
			<div class="file-wrap-title">{{dataVal.title}}<span v-show="dataVal.require" class="require">*</span> </div>
			<div class="input_value">{{dataVal.value?dataVal.value:dataVal.placeholder}}<span class="icon-right"></span> </div>
		</div>
	</div>
</template>

<script>
	export default{
		props:['dataVal']
	}
</script>

<style>
	@import "../../assets/css/common.css";
</style>
